module.exports = __webpack_public_path__ + "d442fbc5d1a7af15c92d6d968ddd93d3.MP3";